import { useQuery } from '@hooks/reactQuery';

import { getPortalTaskById } from '@api/portalTasks';

import { extractQueryParams } from '@utils/common';

import { IPortalTaskDTO } from '@interfaces/portal/dto/taskManagementDTO';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_TASK } from '@constants/queryKeys';

interface IUseQueryPortalTaskReturned {
	isFetchingPortalTask: boolean;
	portalTask?: IPortalTaskDTO;
}

export const useQueryPortalTask = (id: string | null): IUseQueryPortalTaskReturned => {
	const {
		data,
		isFetching,
	} = useQuery<IPortalTaskDTO>({
			queryKey: [GET_PORTAL_TASK, id],
			queryFn: extractQueryParams(getPortalTaskById),
			enabled: [!!id],
			...refetchOptions,
		},
	);

	return {
		isFetchingPortalTask: isFetching,
		portalTask: data,
	};
};
